import type { HttpMock } from '#e2e-utils/mockScenarios';

export const sessionExpiredMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId$',
    },
    response: {
      status: 401,
      body: {},
    },
  },
];
